/* Posy & Plan product page: swipeable gallery with a thumbnail column, edition pills, and the phone buy bar.
   Small on purpose: no libraries. Without JavaScript the page still works (the buy form posts normally). */
(function () {
  'use strict';

  function init(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Gallery ---------- */
    var stage = root.querySelector('[data-pp-stage]');
    var slides = root.querySelectorAll('[data-pp-slide]');
    var thumbs = root.querySelectorAll('[data-pp-thumb]');
    var dots = root.querySelectorAll('[data-pp-dot]');
    var active = 0;

    function setActive(i) {
      active = i;
      for (var t = 0; t < thumbs.length; t++) thumbs[t].toggleAttribute('aria-current', t === i);
      for (var d = 0; d < dots.length; d++) dots[d].toggleAttribute('aria-current', d === i);
      if (thumbs[i] && thumbs[i].scrollIntoView && thumbs[i].parentNode.parentNode.scrollHeight > thumbs[i].parentNode.parentNode.clientHeight) {
        thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    function goTo(i) {
      if (!slides[i]) return;
      stage.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }

    if (stage && slides.length > 1) {
      for (var t = 0; t < thumbs.length; t++) thumbs[t].addEventListener('click', goTo.bind(null, t));
      for (var d = 0; d < dots.length; d++) dots[d].addEventListener('click', goTo.bind(null, d));
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(active + 1, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(active - 1, 0)); }
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) setActive(Number(en.target.getAttribute('data-pp-slide')));
          });
        }, { root: stage, threshold: [0.6] });
        for (var s = 0; s < slides.length; s++) io.observe(slides[s]);
      }
    }

    /* ---------- Edition pills ---------- */
    var dataEl = root.querySelector('[data-pp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var idInput = root.querySelector('[data-pp-variant-id]');
    var priceEl = root.querySelector('[data-pp-price]');
    var buy = root.querySelector('[data-pp-buy]');
    var buyLabel = root.querySelector('[data-pp-buy-label]');
    var stickyName = root.querySelector('[data-pp-sticky-name]');
    var stickyPrice = root.querySelector('[data-pp-sticky-price]');
    var stickyBuy = root.querySelector('[data-pp-sticky-buy]');
    var fieldsets = root.querySelectorAll('[data-pp-option]');

    function selectedOptions() {
      var out = [];
      for (var i = 0; i < fieldsets.length; i++) {
        var c = fieldsets[i].querySelector('input:checked');
        out.push(c ? c.value : null);
      }
      return out;
    }

    function updateVariant() {
      if (!fieldsets.length) return;
      var sel = selectedOptions();
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) if (variants[i].options[j] !== sel[j]) ok = false;
        if (ok) { v = variants[i]; break; }
      }
      if (!v) {
        buy.disabled = true; stickyBuy.disabled = true; buyLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      var note = root.querySelector('[data-pp-launch-note]');
      if (note && v.rise) note.textContent = (note.getAttribute('data-template') || '').replace('[price]', v.rise);
      stickyPrice.textContent = v.price;
      stickyName.textContent = v.name;
      buy.disabled = !v.available;
      stickyBuy.disabled = !v.available;
      buyLabel.textContent = v.available ? 'Buy now' : 'Sold out';
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.pp-pill input')) updateVariant();
    });

    /* ---------- Phone buy bar ---------- */
    var bar = root.querySelector('[data-pp-sticky]');
    if (bar && buy && 'IntersectionObserver' in window) {
      document.body.classList.add('pp-has-pdp-bar');
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting; // shown whenever the main Buy button is off screen (above or below)
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        stickyBuy.tabIndex = visible ? 0 : -1;
      }, { threshold: 0 }).observe(buy);
    }
  }

  function start() {
    var roots = document.querySelectorAll('[data-pp-product]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
